/*
 *  (c) 2015 - 2025 ENISCO by FORCAM GmbH
 */

import {Button, DialogTitle, Stack, Tab, Tabs} from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {DialogEntry} from './MyProfileDialog'
import {useTheme} from '@mui/material/styles'

interface MyProfileTabSetProps {
  value: number
  entries: DialogEntry[]
  onClose: () => void
  setValue: (newValue: number) => void
}

const MyProfileDialogTitleSet: React.FC<MyProfileTabSetProps> = ({
                                                                   onClose,
                                                                   value,
                                                                   setValue,
                                                                   entries
                                                                 }) => {
  const theme = useTheme()
  return (
    <DialogTitle sx={{padding: 0}}>
      <Stack direction={'row'} sx={{backgroundColor: 'background.dark'}}>
        <Tabs
          aria-label='my-profile'
          orientation='horizontal'
          variant='fullWidth'
          value={value}
          sx={{
            width: {xs: 'calc(100% - 64px)', sm: '100%'},
            borderBottom: `1px solid ${theme.palette.divider}`
          }}
          onChange={(_, newValue) => setValue(newValue)}
        >
          {entries.map((entry) => (
            <Tab
              label={entry.createLabel()}
              key={entry.key}
              data-testid={`MyProfileDialogTitleSet:${entry.key}`}
            />
          ))}
        </Tabs>
        <Button
          onClick={onClose}
          data-testid='MyProfileDialogTitleSet:close'
          sx={{
            display: {sm: 'flex', md: 'none'},
            borderBottom: `1px solid ${theme.palette.divider}`
          }}
        >
          <CloseIcon />
        </Button>
      </Stack>
    </DialogTitle>
  )
}

export default MyProfileDialogTitleSet
